import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError, filter } from 'rxjs/operators';
import { throwError } from 'rxjs/internal/observable/throwError';

// Providers-Services
import { ApiRestService } from '../services/shared/api-rest.service';
import { NotifyService } from './shared/notify.service';
import { SpinnerService } from './spinner.service';

// import tablas
import { table } from '../components/shared/tables';

@Injectable({
  providedIn: 'root'
})
export class DocumentosService {

  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService,
    public _notifyService: NotifyService,
    private _spinnerService: SpinnerService
  ) { }

  // tslint:disable: max-line-length
  // Consulta documento enviandole objc y devuelve prnt
  getDocumentosPrnt(objc) {
    console.log(objc)
    let objStr = JSON.stringify(objc);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    objStr = encodeURIComponent(objStr);
    return this.http.get(this._apiRestService.APIURL.serv5 + `/{"tble":"${table.docu}","objc":${objStr}}`)
      .pipe(map((res: Response) => {
        return res;
      })
      );
  }

  // Selecciona tipo de tabla Docu a cargar, opt= true para Developer
  selectDoc(opt, dvision, unidad, old?) {
    switch (old) {
      case true:
        if (opt === true) {
          return this.getDocCerradas();
        } else {
          return this.getDocCerradasUni(dvision, unidad)
        }

      default:
        if (opt === true) {
          return this.getDocumentos();
        } else {
          return this.getDocumentosUni(dvision, unidad)
        }
    }
  }

  // Consulta todos los documentos para datatable
  getDocumentos() {
    return this.http.get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.docu}"}`)
      .pipe(map((res: Response) => {
        let dataUser = { data: res };
        return dataUser;
      })
      );
  }

  // Consulta todos los documentos para datatable por unidad del usuario actual
  getDocumentosUni(dvsion, unidad) {
    let atrb;
    let valor;
    let erro = { status: 403 };

    if (dvsion === undefined) {
      return throwError(erro);
      // return Observable.create([]);
    } else if (dvsion === undefined && unidad === undefined) {
      return throwError(erro);
    } else if (unidad === undefined || unidad[0] === '') {
      atrb = 'dvsionContraOwner';
      valor = dvsion[0];
    } else {
      atrb = 'unidadContraOwner';
      valor = unidad[0];
    }

    return this.http.get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.docu}", "unit":"true"}`)
      .pipe(map((res: any) =>
        res.filter(res =>
          res[atrb] !== undefined && res[atrb][0] === valor))
      );
  }

  // Consulta todos los documentos para datatable con meta
  getDocumentosMeta(opt?) {
    let path;
    if (opt === 'Incompleto') {
      path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.docu}","objc":{"etapa":"${opt}"}}`
    } else {
      path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.docu}","type":"${table.type.meta}"}`;
    }
    return this.http.get(path)
      .pipe(map((res: Response) => {
        let dataUser = { data: res };
        return dataUser;
      })
      );
  }

  // Consulta documento por padre(prnt)
  getDocumento(prnt, type) {
    let path;
    if (type === 'old') {
      path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.docuOldr}","type":"${table.type.metaExtn}","objc":{"prnt":"${prnt}"}}`;
    } else {
      path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.docu}","type":"${table.type.metaExtn}","objc":{"prnt":"${prnt}"}}`;
    }
    return this.http.get(path)
      .pipe(map((res: Response) => {
        return res;
      })
      );
  }

  // Consulta documento por número de folio y oc
  //getDocumentoByFolioOC(folio, oc) {
  getDocumentoByFolio(folio) {
    let path;

    //folio y oc
    //path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.docu}","objc":{"${"Numero"}":"${folio}","${"ocCodigos"}":"${oc}"}}`;
    path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.docu}","objc":{"${"Numero"}":"${folio}"}}`;

    return this.http.get(path)
      .pipe(map((res: Response) => {
        return res;
      })
      );
  }

  // Nuevo Documento
  public newDocumento(newDoc) {
     console.log('newDoc');
    // Se eliminan los atributos que no se guardaran
    delete newDoc.rutProv;
    delete newDoc.tble_prov;
    delete newDoc.saldoOc;
    delete newDoc.balance;
    delete newDoc.PorcentajeIva;
    delete newDoc.balance;
    delete newDoc.fechaOc;
    delete newDoc.item;

    let objStr = JSON.stringify(newDoc);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    objStr = encodeURIComponent(objStr);
    // console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.docu}","objc":${objStr}}`)
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.docu}","objc":${objStr}}`
    ).pipe(map((res: any) => {
      return res;
    })
    );
  }

  // Actualizar Documento
  public updateDocumento(newDoc, prnt) {
    // Se eliminan los atributos que no se guardaran
    delete newDoc.rutProv;
    delete newDoc.tble_prov;
    delete newDoc.saldoOc;
    delete newDoc.balance;
    delete newDoc.PorcentajeIva;
    delete newDoc.balance;
    delete newDoc.fechaOc;
    delete newDoc.item;
    delete newDoc.prnt;

    let objStr = JSON.stringify(newDoc);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    // console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.docu}","prnt":"${prnt}","objc":${objStr}}`)
    objStr = encodeURIComponent(objStr);
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.docu}","prnt":"${prnt}","objc":${objStr}}`
    ).pipe(map((res: any) => {
      return res;
    })
    );
  }

  // Eliminar atributo de la doc, para actualizar. con objeto nuevo
  deleteDocAtrb(prnt, obj) {
    // delete obj.prnt;
    let objStr = JSON.stringify(obj);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    // console.log(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.docu}","prnt":"${prnt}","objc":${objStr}}`);
    objStr = encodeURIComponent(objStr);
    return this.http.get(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.docu}","prnt":"${prnt}","objc":${objStr}}`
    ).pipe(map((res: any) => {
      let data = res;
      return data;
    })
    );
  }

  // Nuevo Item
  public newItem(newItem) {
    let objStr = JSON.stringify(newItem);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    // console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.item}","objc":${objStr}}`)
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.item}","objc":${objStr}}`)
      .pipe(map((res: any) => {
        return res;
      })
      );
  }

  // Nuevo Producto
  public newProd(newProd) {
    let objStr = JSON.stringify(newProd);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    // console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.prod}","objc":{"Producto":${objStr}}}`)
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.prod}","objc":{"Producto":${objStr}}}`)
      .pipe(map((res: any) => {
        return res;
      })
      );
  }

  // Editar item existente
  public editItem(prnt, item) {
    // console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.item}","prnt":"${prnt}","objc":{"cargo":${JSON.stringify(item.cargo)},"descuento":${JSON.stringify(item.descuento)},"fraccion":${JSON.stringify(item.fraccion)},"unidades":${JSON.stringify(item.unidades)},"valor":${JSON.stringify(item.valor)}}}`)
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.item}","prnt":"${prnt}","objc":{"cargo":${JSON.stringify(item.cargo)},"descuento":${JSON.stringify(item.descuento)},"fraccion":${JSON.stringify(item.fraccion)},"unidades":${JSON.stringify(item.unidades)},"valor":${JSON.stringify(item.valor)}}}`)
      .pipe(map((res: any) => {
        return res;
      })
      );
  }

  // Borrar atributo de item
  public delItemAtrb(prnt, item) {

    if (item.cargo === undefined) {
      item.cargo = null;
    }
    if (item.descuento === undefined) {
      item.descuento = null;
    }
    if (item.fraccion === undefined) {
      item.fraccion = null;
    }
    if (item.unidades === undefined) {
      item.unidades = null;
    }
    if (item.valor === undefined) {
      item.valor = null;
    }
    // console.log(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.item}","prnt":"${prnt}","objc":{"cargo":${JSON.stringify(item.cargo)},"descuento":${JSON.stringify(item.descuento)},"fraccion":${JSON.stringify(item.fraccion)},"unidades":${JSON.stringify(item.unidades)},"valor":${JSON.stringify(item.valor)}}}`)
    return this.http.get(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.item}","prnt":"${prnt}","objc":{"cargo":${JSON.stringify(item.cargo)},"descuento":${JSON.stringify(item.descuento)},"fraccion":${JSON.stringify(item.fraccion)},"unidades":${JSON.stringify(item.unidades)},"valor":${JSON.stringify(item.valor)}}}`)
      .pipe(map((res: any) => {
        return res;
      })
      );
  }

  // Valida si el documento existe (número y rut del proveedor)
  validDoc(doc, prov, etapa) {
    // console.log(this._apiRestService.APIURL.serv5 + `/{"tble":"${table.docu}","objc":{"Numero":"${doc}","proveedor":"${prov}","etapa":"${etapa}"}}`);
    return this.http.get(this._apiRestService.APIURL.serv5 + `/{"tble":"${table.docu}","objc":{"Numero":"${doc}","proveedor":"${prov}","etapa":"${etapa}"}}`)
      .pipe(map((res: Response) => {
        return res;
      })
      );
  }

  // Valida si el item existe
  validItem(item) {
    // console.log(this._apiRestService.APIURL.serv4 + `/{"tble":"${table.item}","objc":{"Numero":"${item}"}}`);
    return this.http.get(this._apiRestService.APIURL.serv4 + `/{"tble":"${table.item}","objc":{"Numero":"${item}"}}`)
      .pipe(map((res: Response) => {
        return res;
      })
      );
  }

  // Valida si el producto existe
  validProd(prod) {
    // console.log(this._apiRestService.APIURL.serv4 + `/{"tble":"${table.prod}","objc":{"Producto":"${prod}"}}`);
    return this.http.get(this._apiRestService.APIURL.serv4 + `/{"tble":"${table.prod}","objc":{"Producto":"${prod}"}}`)
      .pipe(map((res: Response) => {
        return res;
      })
      );
  }

  // Cerrar documento, envia a tabla old
  cerrarDoc(prnt) {
    // console.log(this._apiRestService.APIURL.serv10 + `/{"tble":"${table.docu}","prnt":"${prnt}","type":"${table.type.toOld}"}`);
    return this.http.get(this._apiRestService.APIURL.serv10 + `/{"tble":"${table.docu}","prnt":"${prnt}","type":"${table.type.toOld}"}`
    ).pipe(map((res: any) => {
      let data = res;
      return data;
    }));
  }

  // Consulta de todos los documentos cerradas
  public getDocCerradas() {
    // return this.http.get('assets/data/pruebaoc.json') // return res si se va a probar
    return this.http.get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.docuOldr}"}`)
      .pipe(map((res: Response) => {
        let dataUser = { data: res };
        return dataUser;
      }));
  }

  // Consulta de todos los documentos cerradas filtrados por unidad
  public getDocCerradasUni(dvsion, unidad) {
    let atrb;
    let valor;
    let erro = { status: 403 };

    if (dvsion === undefined) {
      return throwError(erro);
      // return Observable.create([]);
    } else if (dvsion === undefined && unidad === undefined) {
      return throwError(erro);
    } else if (unidad === undefined || unidad[0] === '') {
      atrb = 'dvsionContraOwner';
      valor = dvsion[0];
    } else {
      atrb = 'unidadContraOwner';
      valor = unidad[0];
    }

    // return this.http.get('assets/data/pruebaoc.json') // return res si se va a probar
    return this.http.get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.docuOldr}","unit":"true"}`)
      .pipe(map((res: any) =>
        res.filter(res =>
          res[atrb] !== undefined && res[atrb][0] === valor))
      );
  }

  // Consulta OC asociadas a documentos
  public getOcByDoc(oc, old) {
    let tabla;
    if (old === true) {
      tabla = table.docuOldr;
    } else {
      tabla = table.docu;
    }

    // console.log(this._apiRestService.APIURL.serv6 + `/{"tble":"${tabla}","type":"${table.type.metaExtn}","objc":{"ocCodigos":${JSON.stringify(oc)}}}`);
    return this.http.get(this._apiRestService.APIURL.serv6 + `/{"tble":"${tabla}","type":"${table.type.metaExtn}","objc":{"ocCodigos":${JSON.stringify(oc)}}}`)
      .pipe(map((res: Response) => {
        let dataUser = { data: res };
        return dataUser;
      }));
  }

  // Nuevo Proveedores
  public nuevoDocumentoManual(newDoc) {
    let objStr = JSON.stringify(newDoc);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    objStr = encodeURIComponent(objStr);
    console.log("nuevaFactura SERVICIO");
    console.log(newDoc);
    console.log(objStr);
    //console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.prov}","objc":${objStr}}`);
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.facturas}","objc":${objStr}}`
    ).pipe(map
      ((res: any) => {
        return res;
      }));
  }

  getFacturaByAtrb(atrb1, opt1, atrb2, opt2) {
    let path;
    //path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.facturas}","objc":{"${atrb}":"${opt}"}}`
    path = this._apiRestService.APIURL.serv6 +
      `/{"tble":"${table.facturas}","objc":{"${atrb1}":"${opt1}","${atrb2}":"${opt2}"}}`;

    return this.http.get(path)
      .pipe(map((res: Response) => {
        let dataUser = { data: res };
        return dataUser;
      })
      );
  }

  // Actualizar factura
  public updateFactura(newFac, prnt) {
    let objStr = JSON.stringify(newFac);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    objStr = encodeURIComponent(objStr);
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.facturas}","prnt":"${prnt}","objc":${objStr}}`
    ).pipe(map((res: any) => {
      return res;
    })
    );
  }

}
